export function getContainerVisibility(container: Element): number {
  const { top, height } = container.getBoundingClientRect();
  const current = window.innerHeight - top;
  const max = window.innerHeight + height;
  return current / max;
}
